<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Content -->
  <div class="flex flex-col gap-3 flex-1 overflow-hidden">
    <!-- Status Grid (2x2) -->
    <div class="flex flex-col gap-3 w-full">
      <!-- Row 1: Offen + In Bearbeitung -->
      <div class="flex flex-row gap-3 w-full">
        <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 flex-1 px-3 py-3 bg-gray-50 rounded-lg" tooltip="Offen"
             tooltipDirection="top">
          <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
            <fa-icon [icon]="faMoonFull" class="text-sm text-gray shrink-0"></fa-icon>
            <span class="text-gray-900 text-sm font-medium truncate">Offen</span>
          </div>
          <span class="text-gray-900 text-lg font-medium shrink-0">{{ open }}</span>
        </div>
        <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 flex-1 px-3 py-3 bg-gray-50 rounded-lg" tooltip="In Bearbeitung"
             tooltipDirection="top">
          <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
            <fa-icon [icon]="faCircleHalfStroke" class="text-sm -rotate-90 text-gray shrink-0"></fa-icon>
            <span class="text-gray-900 text-sm font-medium truncate">In Bearbeitung</span>
          </div>
          <span class="text-gray-900 text-lg font-medium shrink-0">{{ inProgress }}</span>
        </div>
      </div>
      <!-- Row 2: Verifiziert + Erledigt -->
      <div class="flex flex-row gap-3 w-full">
        <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 flex-1 px-3 py-3 bg-gray-50 rounded-lg" tooltip="Verifiziert"
             tooltipDirection="top">
          <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
            <fa-icon [icon]="faCircleCheck" class="text-sm text-gray shrink-0"></fa-icon>
            <span class="text-gray-900 text-sm font-medium truncate">Verifiziert</span>
          </div>
          <span class="text-gray-900 text-lg font-medium shrink-0">{{ verified }}</span>
        </div>
        <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 flex-1 px-3 py-3 bg-gray-50 rounded-lg" tooltip="Erledigt"
             tooltipDirection="top">
          <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
            <fa-icon [icon]="faCircle" class="text-sm text-gray shrink-0"></fa-icon>
            <span class="text-gray-900 text-sm font-medium truncate">Erledigt</span>
          </div>
          <span class="text-gray-900 text-lg font-medium shrink-0">{{ done }}</span>
        </div>
      </div>
    </div>

    <!-- Meine Tasks Sektion -->
    <div class="flex flex-col gap-2 flex-1 overflow-hidden">
      <span class="text-gray-900 text-sm font-medium">Meine Tasks</span>
      @if (hasTasks && myTasks.length > 0) {
        <div class="flex flex-col gap-3 flex-1 overflow-auto">
          @for (task of myTasks; track task.taskName) {
            <div class="flex flex-row items-center gap-3">
              <div class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full shrink-0">
                <span class="font-medium text-gray-900 text-[10px]">{{ task.assignedUserInitials || '?' }}</span>
              </div>
              <span class="text-gray-900 text-sm font-normal flex-1 min-w-0 truncate">{{ task.taskName }}</span>
              @if (task.dueDate) {
                <div class="flex flex-row items-center gap-1.5 shrink-0"
                     [ngClass]="isOverdue(task.dueDate) ? 'text-red-500' : 'text-gray-500'">
                  <fa-icon [icon]="faCalendarDays" class="text-xs"></fa-icon>
                  <span class="text-sm font-medium">{{ task.dueDate | date:'dd.MM.yyyy' }}</span>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div [appSkeletonLoading]="loading" class="flex flex-col gap-2 flex-1 overflow-clip rounded-lg">
          <app-empty-state [icon]="faListCheck" message="Es wurden noch keine Tasks erstellt"></app-empty-state>
        </div>
      }
    </div>
  </div>

</div>
